// src/App.tsx
import Router from './routes';
import { Toaster } from 'react-hot-toast';
import AppWrapper from './AppWrapper';

const App: React.FC = () => {
  return (
    <AppWrapper>
      <div className="min-h-screen bg-dark text-dark dark:bg-dark dark:text-light transition-colors duration-300 relative">
        {/* ✅ Floating Theme Toggle (top-right corner) */}
        <div className="fixed top-4 right-4 z-50"></div>

        {/* ✅ Global Toaster config */}
        <Toaster
          position="top-center"
          reverseOrder={false}
          toastOptions={{
            success: {
              style: {
                background: '#10B981',
                color: '#fff',
              },
            },
            error: {
              style: {
                background: '#EF4444',
                color: '#fff',
              },
            },
          }}
        />

        {/* ✅ Main Routing */}
        <Router />
      </div>
    </AppWrapper>
  );
};

export default App;
